<template>
  <div id="page-receipt"
       class="container-fluid">

    <receipt-filter v-show="!showPreview"
                    @get-receipt="getReceipt"
                    @change-filter-type="changeFilterType">
    </receipt-filter>

    <div v-show="!showPreview"
         class="panel position-relative">
      <div class="row mb-3">
        <div class="col-md-12">
          <receipt-list :receipts-list="receiptsList"
                        @on-show-preview="onShowPreview">
          </receipt-list>
          <pagination v-if="receiptsList"
                      ref="pagination"
                      :total-count="receiptsList['totalCount']"
                      :per-page="receiptsList['count']"
                      @changePage="changePage">
          </pagination>
        </div>
      </div>
      <main-loader></main-loader>
    </div>

    <div v-if="showPreview"
         class="position-relative">
      <receipt-preview :receipt="receipt"
                       @close="closePreview">
      </receipt-preview>
      <main-loader></main-loader>
    </div>

  </div>
</template>

<script>
  import MSG from '@/services/notify';
  import MainLoader from '@/components/Loader';
  import { ApiFiscalDocs } from '@/services/api';
  import ReceiptFilter from '@/views/FiscalDocs/Receipt/Filter';
  import ReceiptList from '@/views/FiscalDocs/Receipt/List';
  import Pagination from '@/components/Pagination';
  import ReceiptPreview from '@/views/FiscalDocs/Receipt/Preview';


  export default {
    name: 'FDReceipt',
    components: {
      Pagination,
      ReceiptList,
      MainLoader,
      ReceiptFilter,
      ReceiptPreview
    },

    data() {
      return {
        showPreview: false,
        receiptsList: null,
        receipt: null,
        filter: null
      };
    },

    mounted() {
      this.$store.commit('setPageTitle', '#TR-fiscal-docs-receipt');
    },

    methods: {

      changeFilterType() {
        this.receiptsList = null;
      },

      async getReceipt(filter) {

        if (!filter[filter.type].paging) {
          filter[filter.type].paging = {
            from: 1,
            qty: 15
          };
        }

        if (filter.type === 'byNum') {
          await this.getReceiptByNum(filter[filter.type]);
        } else {
          await this.getReceiptByFilter(filter[filter.type]);
        }
      },

      async getReceiptByNum(filter) {

        filter = filter || {};
        filter.receiptNum = filter.receiptNum || null;

        this.filter = filter;
        this.filter.type = 'byNum';
        this.$store.commit('toggleLoader', true);

        const result = await ApiFiscalDocs.Receipts.getByNum(filter);

        if (!result.error) {
          this.receiptsList = result.data;
          this.$nextTick(() => {
            this.$refs.pagination.setPage(filter.paging);
          });
        } else {
          MSG.error(result.error, this);
        }
        this.$store.commit('toggleLoader', false);
      },

      async getReceiptByFilter(filter) {

        this.filter = filter;
        this.filter.type = 'byFilter';
        this.$store.commit('toggleLoader', true);

        const result = await ApiFiscalDocs.Receipts.getByFilter(this.filter);

        if (!result.error) {
          this.receiptsList = result.data;
          this.$nextTick(() => {
            this.$refs.pagination.setPage(filter.paging);
          });
        } else {
          MSG.error(result.error, this);
        }
        this.$store.commit('toggleLoader', false);
      },

      changePage(from) {

        this.filter.paging = {
          from: from,
          qty: 15
        };

        if (this.filter.type === 'byNum') {
          this.getReceiptByNum(this.filter);
        } else {
          this.getReceiptByFilter(this.filter);
        }
      },

      onShowPreview(receipt) {
        this.receipt = receipt;
        this.showPreview = true;
      },

      closePreview() {
        this.showPreview = false;
      }

    }
  };
</script>

<style lang="stylus">
#page-receipt {
  position: relative
  min-height: 100%

  .nav-link {
    text-transform: uppercase
    font-size: 14px
    background: md-grey-300
    color: md-grey-700
    cursor: pointer

    &:hover {
      /*color: md-grey-900 !important*/
    }

    &.active {
      background: c-accent
      color: md-white
    }
  }
}

.receipt-btn {
  width: 40px;
  padding: 0 !important;
  cursor: pointer;

  .mdi {
    font-size: 30px;
    line-height: 44px;
    display: block;
  }

  &.edit {
    color: md-brown-500

    &:hover {
      color: md-brown-700
    }
  }

  &.preview {
    color: c-accent

    &:hover {
      color: c-accent
    }
  }

  &.receipt {
    color: md-blue-grey-600

    &:hover {
      color: md-blue-grey-700
    }
  }

  &.disable {
    color: md-grey-400
    cursor: not-allowed

    &:hover {
      color: md-grey-400
      cursor: not-allowed
    }
  }
}

.selected-rest {
  background: c-accent;
  display: inline-block;
  margin: 0 5px 6px 0;
  font-size: 14px;
  padding: 3px 10px;
  color: #fff;
}

.rest {
  position: relative
}

.rest-selector {
  z-index: 9999;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  width: 500px;
  height: auto;
  padding: 20px;

  .list-group-item.active {
    border-color: white
  }
}

.check-all-rest {
  width: 80px
  cursor: pointer
  color: md-grey-500
  overflow: hidden

  .mdi {
    font-size: 30px
    line-height: 30px
    float: left
  }

  .text {
    font-size: 18px;
    float: left;
    line-height: 32px;
    margin-left: 10px;
  }

  &.checked {
    color: c-accent
  }
}

.fade2-leave-active {
  display: none

}

.fade2-enter-active {
  //opacity: 0
  transition: all 500ms
}

.fade2-enter {
  opacity: 0
  transform: scale(1, 0.5)
}

.fade2-enter-to {
  opacity: 1
  transform: scale(1, 1)

}


.darkmode {
  #page-receipt {
    .nav-link {
      background: c-dark-bg
      color: c-body-font-dark
      border: 1px solid c-dark-bg-light

      &.active {
        background: c-accent-dark
        color: c-body-font-dark
      }
    }
  }

  .receipt-btn {
    &.preview {
      color: c-accent-dark

      &:hover {
        color: c-accent-dark
      }
    }
  }

  .selected-rest {
    background: c-accent-dark;
    color: #fff;
  }

  .rest-selector {
    background: c-dark-bg;
    .list-group-item.active {
      border-color: c-dark-bg-light
    }
  }

  .check-all-rest {
    &.checked {
      color: c-accent-dark
    }
  }
}

@media (max-width: 640px) {
  .rest-selector {
    width: 100% !important;
  }
}
</style>
